/**
 * Toast Configuration Utility
 * Centralized toast notification configuration
 */

/**
 * Default toast configuration
 */
export const defaultToastConfig = {
  position: "bottom-right",
  autoClose: 2000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
  theme: "light",
};

/**
 * Get toast configuration with custom options
 * @param {Object} overrides - Configuration overrides
 * @returns {Object} Toast configuration object
 */
export const getToastConfig = (overrides = {}) => {
  return {
    ...defaultToastConfig,
    ...overrides,
  };
};

/**
 * Predefined toast configurations
 */
export const toastConfigs = {
  // Short duration toasts (1.5 seconds)
  short: getToastConfig({
    autoClose: 1500,
  }),

  // Medium duration toasts (2 seconds) - default
  medium: getToastConfig({
    autoClose: 2000,
  }),

  // Long duration toasts (3.5 seconds)
  long: getToastConfig({
    autoClose: 3500,
  }),

  // Error toasts
  error: getToastConfig({
    autoClose: 2000,
    theme: "light",
  }),

  // Success toasts
  success: getToastConfig({
    autoClose: 2000,
    theme: "light",
  }),

  // Info toasts
  info: getToastConfig({
    autoClose: 2000,
    theme: "light",
  }),

  // Warning toasts
  warning: getToastConfig({
    autoClose: 2000,
    theme: "light",
  }),
};
